var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNavMontage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 211,
    height: 223,
    viewBox: "0 0 211 223",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M149.979 222.41C154.307 222.41 157.815 218.902 157.815 214.574L157.815 152.965C157.815 68.9644 89.719 0.868582 5.71855 0.868588V0.868588C2.63854 0.868589 0.141692 3.36544 0.141693 6.44545L0.141737 211.41C0.141738 217.485 5.06661 222.41 11.1417 222.41L149.979 222.41Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M175.657 222.41V147.303C175.804 132.74 170.363 97.9132 153.814 70.9616C139.075 46.9576 123.464 32.599 117.914 28.2691C142.404 11.0068 172.277 0.868533 204.517 0.86853C208.033 0.86853 210.884 3.71909 210.884 7.23543L210.884 211.41C210.884 217.485 205.959 222.41 199.884 222.41H175.657ZM76.6653 222.41L61.9238 222.344C62.2829 222.388 62.6484 222.41 63.0192 222.41H76.6653Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavMontage);
export default __webpack_public_path__ + "static/media/nav-montage.52fcb7ce957ab87bf7e831ad239bebf9.svg";
export { ForwardRef as ReactComponent };